import apiClient from "./axios";

const BASE_PATH = "/v3/sales";

export const salesRevenueApi = {
    listRoutes: (params = {}) => apiClient.get(`${BASE_PATH}/routes`, { params }),
    getRoute: (routeId) => apiClient.get(`${BASE_PATH}/routes/${routeId}`),
    createRoute: (data) => apiClient.post(`${BASE_PATH}/routes`, data),
    updateRoute: (routeId, data) => apiClient.put(`${BASE_PATH}/routes/${routeId}`, data),
    activateRoute: (routeId) => apiClient.post(`${BASE_PATH}/routes/${routeId}/activate`),
    deactivateRoute: (routeId) => apiClient.post(`${BASE_PATH}/routes/${routeId}/deactivate`),

    listContracts: (params = {}) => apiClient.get(`${BASE_PATH}/charter-contracts`, { params }),
    getContract: (contractId) => apiClient.get(`${BASE_PATH}/charter-contracts/${contractId}`),
    createContract: (data) => apiClient.post(`${BASE_PATH}/charter-contracts`, data),
    updateContract: (contractId, data) => apiClient.put(`${BASE_PATH}/charter-contracts/${contractId}`, data),
    activateContract: (contractId) => apiClient.post(`${BASE_PATH}/charter-contracts/${contractId}/activate`),
    deleteAcmiSubstitute: (contractId, substituteId) => apiClient.delete(`${BASE_PATH}/charter-contracts/${contractId}/acmi-substitutes/${substituteId}`),
    terminateContract: (contractId) => apiClient.post(`${BASE_PATH}/charter-contracts/${contractId}/terminate`),

    listContractBookings: (contractId, params = {}) => apiClient.get(`${BASE_PATH}/charter-contracts/${contractId}/bookings`, { params }),

    createRoutePrice: (contractId, data) => apiClient.post(`${BASE_PATH}/charter-contracts/${contractId}/route-prices`, data),
    updateRoutePrice: (priceId, data) => apiClient.put(`${BASE_PATH}/route-prices/${priceId}`, data),
    deleteRoutePrice: (priceId) => apiClient.delete(`${BASE_PATH}/route-prices/${priceId}`),

    createFuelTiersBatch: (contractId, data) => apiClient.post(`${BASE_PATH}/charter-contracts/${contractId}/fuel-surcharge-tiers/batch`, data),
    updateFuelTier: (tierId, data) => apiClient.put(`${BASE_PATH}/fuel-surcharge-tiers/${tierId}`, data),

    createPrepayment: (data) => apiClient.post(`${BASE_PATH}/prepayments`, data),
    listCustomerCredits: (customerId, params = {}) => apiClient.get(`${BASE_PATH}/customers/${customerId}/credits`, { params }),
    getCreditLedger: (creditLedgerId) => apiClient.get(`${BASE_PATH}/credits/${creditLedgerId}`),
    listCreditUsages: (creditLedgerId, params = {}) => apiClient.get(`${BASE_PATH}/credits/${creditLedgerId}/usages`, { params }),

    listReceivables: (params = {}) => apiClient.get(`${BASE_PATH}/receivables`, { params }),
    listReceivablesByBooking: (params = {}) => apiClient.get(`${BASE_PATH}/receivables/by-booking`, { params }),
    listBookingFlights: (bookingId) => apiClient.get(`${BASE_PATH}/receivables/by-booking/${bookingId}/flights`),
    getReceivable: (receivableId) => apiClient.get(`${BASE_PATH}/receivables/${receivableId}`),
    createExtraFeeReceivable: (data) => apiClient.post(`${BASE_PATH}/receivables/extra-fees`, data),
    adjustReceivableAmount: (receivableId, data) => apiClient.patch(`${BASE_PATH}/receivables/${receivableId}/amount`, data),
    generateBaseReceivable: (bookingId) => apiClient.post(`${BASE_PATH}/receivables/bookings/${bookingId}/generate-base`),
    rematchBaseReceivable: (bookingId, { force = false } = {}) => apiClient.post(`${BASE_PATH}/receivables/bookings/${bookingId}/rematch`, null, { params: { force } }),
    recalculateBookingReceivables: (bookingId, { force = false } = {}) => apiClient.post(`${BASE_PATH}/receivables/bookings/${bookingId}/recalculate`, null, { params: { force } }),
    generateBaseReceivablesBatch: (data) => apiClient.post(`${BASE_PATH}/receivables/generate-base-batch`, data),
    previewFuelSurcharge: (data) => apiClient.post(`${BASE_PATH}/fuel-surcharge/preview`, data),
    generateFuelSurcharge: (data, { force = false } = {}) => apiClient.post(`${BASE_PATH}/fuel-surcharge/generate`, data, { params: { force } }),
    recalculateFuelSurcharge: (bookingId, { force = false } = {}) => apiClient.post(`${BASE_PATH}/fuel-surcharge/bookings/${bookingId}/recalculate`, null, { params: { force } }),

    // PER_LEG_BURN 按段油耗：挑段 / 填油耗 / 批量
    getBookingLegFuelSummary: (bookingId) => apiClient.get(`${BASE_PATH}/bookings/${bookingId}/leg-fuel-summary`),
    linkBookingLegForFuel: (bookingId, flightOperationId) => apiClient.post(`${BASE_PATH}/bookings/${bookingId}/leg-fuel-burn/link`, { flight_operation_id: flightOperationId }),
    unlinkBookingLegForFuel: (bookingId, legId) => apiClient.delete(`${BASE_PATH}/bookings/${bookingId}/leg-fuel-burn/${legId}`),
    saveBookingLegFuelBurns: (bookingId, items) => apiClient.put(`${BASE_PATH}/bookings/${bookingId}/leg-fuel-burn`, { items }),
    previewPerLegBurnBatch: (data) => apiClient.post(`${BASE_PATH}/fuel-surcharge/per-leg-burn/preview`, data),
    generatePerLegBurnBatch: (data, { force = false } = {}) => apiClient.post(`${BASE_PATH}/fuel-surcharge/per-leg-burn/generate`, data, { params: { force } }),

    // AD_HOC 一班一议：燃油手填（基础运价按合同航线价生成）
    getBookingAdHocAmount: (bookingId) => apiClient.get(`${BASE_PATH}/bookings/${bookingId}/ad-hoc-amount`),
    saveBookingAdHocAmount: (bookingId, data) => apiClient.put(`${BASE_PATH}/bookings/${bookingId}/ad-hoc-amount`, data),
    generateBookingAdHocReceivables: (bookingId) => apiClient.post(`${BASE_PATH}/bookings/${bookingId}/ad-hoc-amount/generate`),
    refreshCancelledBookingCredit: (bookingId) => apiClient.post(`${BASE_PATH}/credits/cancelled-bookings/${bookingId}/refresh`),
    listInvoices: (params = {}) => apiClient.get(`${BASE_PATH}/invoices`, { params }),
    getInvoice: (invoiceId) => apiClient.get(`${BASE_PATH}/invoices/${invoiceId}`),
    createInvoice: (data) => apiClient.post(`${BASE_PATH}/invoices`, data),
    createInvoiceBatch: (data) => apiClient.post(`${BASE_PATH}/invoices/batch`, data),
    voidInvoice: (invoiceId) => apiClient.post(`${BASE_PATH}/invoices/${invoiceId}/void`),
    createInvoicePayment: (invoiceId, data) => apiClient.post(`${BASE_PATH}/invoices/${invoiceId}/payments`, data),
    listInvoicePayments: (invoiceId, params = {}) => apiClient.get(`${BASE_PATH}/invoices/${invoiceId}/payments`, { params }),
    listInvoicePaymentAllocations: (invoiceId, params = {}) => apiClient.get(`${BASE_PATH}/invoices/${invoiceId}/payment-allocations`, { params }),

    assignBookingCustomer: (bookingId, data) => apiClient.put(`${BASE_PATH}/bookings/${bookingId}/customer`, data),
    unassignBookingContract: (bookingId) => apiClient.delete(`${BASE_PATH}/bookings/${bookingId}/contract`),

    getCargoReportFlights: (params = {}) => apiClient.get(`${BASE_PATH}/cargo-report/flights`, { params }),

    // 航班货运档案（T13/T16/T17/T18）
    getCargoReportDetail: (flightOperationId) => apiClient.get(`${BASE_PATH}/cargo-report/flights/${flightOperationId}`),
    getCargoReportMessages: (flightOperationId, params = {}) => apiClient.get(`${BASE_PATH}/cargo-report/flights/${flightOperationId}/messages`, { params }),
    getCargoReportFiles: (flightOperationId) => apiClient.get(`${BASE_PATH}/cargo-report/flights/${flightOperationId}/files`),
    getCargoReportSourceVersions: (flightOperationId) =>
        apiClient.get(`${BASE_PATH}/cargo-report/flights/${flightOperationId}/source-versions`),
    // 二期：人工补传 CGO 约定文件（单次≤10 个，单文件≤20MB，合计≤50MB）
    uploadCargoReportFiles: (flightOperationId, files) => {
        const formData = new FormData();
        files.forEach((f) => formData.append("files", f));
        return apiClient.post(
            `${BASE_PATH}/cargo-report/flights/${flightOperationId}/files/upload`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } },
        );
    },
    reparseCargoReportFile: (flightOperationId, fileId) =>
        apiClient.post(`${BASE_PATH}/cargo-report/flights/${flightOperationId}/files/${fileId}/reparse`),
    deleteCargoReportFile: (flightOperationId, fileId) =>
        apiClient.delete(`${BASE_PATH}/cargo-report/flights/${flightOperationId}/files/${fileId}`),
    downloadCargoReportFile: (flightOperationId, fileId) =>
        apiClient.get(`${BASE_PATH}/cargo-report/flights/${flightOperationId}/files/${fileId}/download`, {
            responseType: "blob",
            _skipInterceptorProcessing: true,
        }),
    downloadCargoReportPackage: (flightOperationId, fileIds) =>
        apiClient.post(
            `${BASE_PATH}/cargo-report/flights/${flightOperationId}/files/download-package`,
            { file_ids: fileIds },
            { responseType: "blob", _skipInterceptorProcessing: true },
        ),
    downloadCargoReportMessageTxt: (flightOperationId, messageId, messageType) =>
        apiClient.get(`${BASE_PATH}/cargo-report/flights/${flightOperationId}/messages/${messageId}/txt`, {
            responseType: "blob",
            _skipInterceptorProcessing: true,
            params: messageType ? { message_type: messageType } : undefined,
        }),
};

export default salesRevenueApi;
